// Vee Validate

import Vue from 'vue'
import axios from "../backend/vue-axios/axios";
import {ValidationProvider,ValidationObserver, extend, localize} from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr.json';
import { required } from 'vee-validate/dist/rules';
import { confirmed } from 'vee-validate/dist/rules';
import { alpha_dash } from 'vee-validate/dist/rules';
import { digits } from 'vee-validate/dist/rules';
import { email } from 'vee-validate/dist/rules';
import { regex } from 'vee-validate/dist/rules';


localize({
    fr
});

extend('required', {
    ...required,
    message: 'Veuillez compléter ce champs.'
});

extend('confirmed', {
    ...confirmed,
    message: 'Les mot de passe ne correspondent pas.'
});

extend('alpha_dash', {
    ...alpha_dash,
    message: 'Ce champs est invalide, veuillez utiliser uniquement des lettres et des tirets.'
});

extend('digits', {
    ...digits,
    message: "Cette valeur n'est pas valide."
});

extend('passwordCheck', {
    validate: (value) =>{
        let regex = RegExp('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!$%@#£€*?&._-]{8,}$')
        return regex.test(value)
    },
    message: "Le mot de passe doit contenir minimum 8 caractères avec au minimum une lettre et un chiffre."
});

extend('email', {
    ...email,
    message: "Cet adresse e-mail n'est pas valide."
});

extend('emailExists', {
    async validate(value) {
        try {
            let check = await axios.get('/check-mail?email=' + value)
            return true
        } catch(err) {
            return false
        }
    },
    message: "Cette adresse e-mail est déja enregistrée."
})

extend('checkResps', {
    validate: (value) => {
        return value.length <= 2;
    },
    message: "Vous pouvez cocher 2 cases maximum"
})

extend('checkRespsOne', {
    validate: (value) => {
        return value.length === 1;
    },
    message: "Vous pouvez cocher 1 case maximum"
})


extend('major', {
    validate: (value) => {
        const getAge = (birthDate) => {
            let date = new Date(birthDate)
            let ageDifMs = Date.now() - date.getTime();
            let ageDate = new Date(ageDifMs); // miliseconds from epoch

            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }

        return getAge(value) >= 18
    },
    message: 'Cette personne est mineur et ne peut pas être responsable légal.'
});

extend('majorRegistration', {
    validate: (value) => {
        const getAge = (birthDate) => {
            let date = new Date(birthDate)
            let ageDifMs = Date.now() - date.getTime();
            let ageDate = new Date(ageDifMs); // miliseconds from epoch

            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }

        return getAge(value) >= 18
    },
    message: 'Tu es mineur, demande à un de tes parents ou responsable légal de créer son compte et de t’inscrire.'
});





// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
